
<div class="links" *ngFor="let theme of themes">
  <a *ngIf="theme.file" href="{{ theme.file.url }}"><i class="fa-light fa-download"></i>{{ theme.name }}</a>
</div>
